export default {
  // imgURI: 'https://inkankan-1255390650.cos.ap-chengdu.myqcloud.com/'
  imgURI: 'https://inkankan-1313504973.cos.ap-guangzhou.myqcloud.com/inkankan_cn'
}



// WEBPACK FOOTER //
// ./src/config/index.js